import { render, staticRenderFns } from "./MultipleStore.vue?vue&type=template&id=5fc2217a&scoped=true"
import script from "./MultipleStore.vue?vue&type=script&lang=js"
export * from "./MultipleStore.vue?vue&type=script&lang=js"
import style0 from "./MultipleStore.vue?vue&type=style&index=0&id=5fc2217a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fc2217a",
  null
  
)

export default component.exports